/* AE · Signature hero — generated by signature-hero/theme/build.py from signature-hero/index.html. Do not edit here. */
import * as THREE from 'https://cdn.jsdelivr.net/npm/three@0.170.0/build/three.module.min.js';

/* ───────────────────────── product config ───────────────────────── */
const PRODUCTS = {
  daydream: {
    key:'daydream', name:'Daydream', theme:0,
    eyebrow:'Aromatick Daydream · Eau de Parfum',
    h1:'Sunlit tea, <em>bottled.</em>',
    sub:'Citron, black tea and Ambroxan. Made from scratch in Port St. Lucie, Florida.',
    cta:'Shop Daydream — $45', buySm:'Shop Daydream',
    top:{ k:'01 · Top notes', t:'Sicilian Lemon, Calabrian Bergamot, Orange', d:'Bright, sunny citrus. The first thing you notice when you spray it.' },
    heart:{ k:'02 · Heart', t:'Black Tea, Ginger, Cinnamon Bark', d:'A little earthy, a little spiced. This is the part people ask you about.' },
    base:{ k:'03 · Base', t:'Ambroxan, Guaiac Wood, White Musks', d:'That “your skin, but better” glow, and it lasts 8+ hours.' },
    finalH:'The Imagination vibe. <em>Not</em> the $360 price.',
    finalD:'Daydream is our own fragrance, made from scratch. You get a 50ml eau de parfum for $45.',
    ctaFinal:'Add Daydream — $45', cta10:'Try the 10ml — $14.99',
    v50:45376508199027, v10:48377865076851,
    fallback:'https://cdn.shopify.com/s/files/1/0671/1876/0051/files/rn-image_picker_lib_temp_c769e36d-e930-4e44-b273-b7d556aa91bc.webp?v=1787319630&width=900',
    label:{ title:'DAYDREAM', titleFont:'500 186px "Roboto Mono"', size:'50ml 1.7 Fl. OZ. / Eau De Parfum', notes:'Citron • Black Tea • Ambrox', paper:'#f8f8f6', ink:'#151515' },
    liquid:{ tint:'#fff8ec', dist:7.0, glow:'#0d0b08' },
  },
  horizon: {
    key:'horizon', name:'Horizon', theme:1,
    eyebrow:'Aromatick Horizon · Eau de Parfum',
    h1:'First light, <em>bottled.</em>',
    sub:'Grapefruit, ginger and Ambroxan. Made from scratch in Port St. Lucie, Florida.',
    cta:'Shop Horizon — $45', buySm:'Shop Horizon',
    top:{ k:'01 · Top notes', t:'Pink Grapefruit, Bergamot, Ginger', d:'Sharp, bright and a little spicy, right from the first spray.' },
    heart:{ k:'02 · Heart', t:'Rosemary, Sage, Geranium', d:'A green, herbal detour with a water accord. It’s the part people remember.' },
    base:{ k:'03 · Base', t:'Ambroxan, Amber, Labdanum', d:'It settles warm and clean, and stays close to the skin for 8+ hours.' },
    finalH:'The L’Immensité vibe. <em>Not</em> the $360 price.',
    finalD:'Horizon is our own fragrance, made from scratch. You get a 50ml eau de parfum for $45.',
    ctaFinal:'Add Horizon — $45', cta10:'Try the 10ml — $14.99',
    v50:45459624329331, v10:48377807241331,
    fallback:'https://cdn.shopify.com/s/files/1/0671/1876/0051/files/aromatick-horizon-eau-de-parfum-50ml-bottle.webp?v=1791046472&width=900',
    label:{ title:'Horizon', titleFont:'400 200px "Courier Prime"', size:'50ml 1.7 FL. OZ. / Eau de Parfum', notes:'Grapefruit • Ginger • Ambrox', paper:'#ebe7e0', ink:'#1d1b19' },
    liquid:{ tint:'#e0943c', dist:1.3, glow:'#361805' },
  },
};

/* ───────────────────────── DOM ───────────────────────── */
const root = document.querySelector('.ash');
const CFG = JSON.parse((root.parentElement.querySelector('.ash-data') || {}).textContent || '{}');
const $ = (s, el = root) => el.querySelector(s);
const $$ = (s, el = root) => [...el.querySelectorAll(s)];
const canvas = $('.ash-canvas');
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const qp = new URLSearchParams(location.search);
for (const k of Object.keys(PRODUCTS)) {
  const c = CFG.products?.[k] || {};
  for (const f of ['url','h1','sub','buySm','fallback']) if (c[f]) PRODUCTS[k][f] = c[f];
}
let active = PRODUCTS[qp.get('p')] ? qp.get('p') : (PRODUCTS[root.dataset.start] ? root.dataset.start : 'horizon');

// pin under the theme's sticky header
function headerOffset(){
  const cs = getComputedStyle(document.documentElement);
  const sticky = parseFloat(cs.getPropertyValue('--header-is-sticky')) || 0;
  let h = parseFloat(cs.getPropertyValue('--header-height')) || 0;
  if (!h) { const el = document.querySelector('.shopify-section[id$="__header"], header'); h = el ? el.offsetHeight : 0; }
  return sticky ? h : 0;
}
const syncHdr = () => root.style.setProperty('--ash-hdr', headerOffset() + 'px');
syncHdr();

function fillCopy(p){
  $$('[data-c]').forEach(el => {
    const path = el.dataset.c.split('.');
    let v = p; for (const k of path) v = v?.[k];
    if (v != null) el.innerHTML = v;
  });
  $$('[data-for]').forEach(el => { el.hidden = el.dataset.for !== p.key; });
  $$('[data-url]').forEach(a => { if (p.url) a.href = p.url; });
  $$('.ash-tab').forEach(t => t.setAttribute('aria-selected', String(t.dataset.p === p.key)));
  if (p.fallback) $('.ash-fallback').src = p.fallback;
  root.dataset.theme = p.key;
}
fillCopy(PRODUCTS[active]);

function webglOK(){
  try { const c = document.createElement('canvas'); return !!(c.getContext('webgl2')); } catch { return false; }
}
if (!webglOK() || !window.gsap) {
  root.classList.add('ash--static', 'ash--reduced');
  $$('.ash-tab').forEach(t => t.addEventListener('click', () => { active = t.dataset.p; fillCopy(PRODUCTS[active]); }));
} else {
  main().catch(err => { console.error(err); root.classList.add('ash--static', 'ash--reduced'); });
}

async function main(){
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
if (reduced) root.classList.add('ash--reduced');

await Promise.all([
  document.fonts.load('500 100px "Roboto Mono"'), document.fonts.load('400 100px "Courier Prime"'),
  document.fonts.load('400 60px Roboto'), document.fonts.load('italic 700 60px Roboto'),
  document.fonts.load('800 100px "DM Sans"'),
]).catch(() => {});

/* ───────────────────────── renderer / scene ───────────────────────── */
const renderer = new THREE.WebGLRenderer({ canvas, antialias:true, powerPreference:'high-performance' });
renderer.outputColorSpace = THREE.SRGBColorSpace;
renderer.toneMapping = THREE.NeutralToneMapping;
renderer.toneMappingExposure = 1.0;
const DPR = Math.min(window.devicePixelRatio || 1, 1.75);
renderer.setPixelRatio(DPR);

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(30, 1, 0.05, 80);
const pmrem = new THREE.PMREMGenerator(renderer);

function makeEnv(dark){
  const s = new THREE.Scene();
  s.background = new THREE.Color(dark ? 0x050404 : 0xd4cec5);
  const C = (r,g,b) => new THREE.Color(r,g,b);
  const panel = (w,h,x,y,z,col) => {
    const m = new THREE.Mesh(new THREE.PlaneGeometry(w,h), new THREE.MeshBasicMaterial({ color:col, side:THREE.DoubleSide }));
    m.position.set(x,y,z); m.lookAt(0, y*0.3, 0); s.add(m);
  };
  panel(1.4,10, -4.6,1, 2.4, C(7,7,7));                                // tall key strip, front-left
  panel(0.8,10,  4.3,1, 2.6, dark ? C(9,4.8,1.9) : C(5.5,5.2,4.8));    // warm rim strip, front-right
  panel(10,2.4, 0,6.2,0, C(2.4,2.4,2.4));                              // top bank
  panel(7,7, 0,0,-6.5, dark ? C(1.7,0.65,0.25) : C(1.8,1.75,1.7));     // back fill
  if (!dark){ panel(3,10,-5.5,1,-2, C(.03,.03,.03)); panel(3,10,5.5,1,-2, C(.03,.03,.03)); panel(12,3,0,-5,0,C(.05,.045,.04)); }
  const t = pmrem.fromScene(s, 0.02).texture;
  s.traverse(o => { o.geometry?.dispose(); o.material?.dispose(); });
  return t;
}
const ENV = { dark: makeEnv(true), light: makeEnv(false) };
scene.environment = PRODUCTS[active].theme > .5 ? ENV.dark : ENV.light;

scene.add(new THREE.HemisphereLight(0xfff4e6, 0x2a2420, 0.55));
const key = new THREE.DirectionalLight(0xffffff, 1.3); key.position.set(-3, 4, 5); scene.add(key);

/* ── shared GLSL ── */
const NOISE = /* glsl */`
  float hash(vec2 p){ return fract(sin(dot(p, vec2(127.1,311.7))) * 43758.5453); }
  float noise(vec2 p){ vec2 i=floor(p), f=fract(p); vec2 u=f*f*(3.-2.*f);
    return mix(mix(hash(i),hash(i+vec2(1,0)),u.x), mix(hash(i+vec2(0,1)),hash(i+vec2(1,1)),u.x), u.y); }
  float fbm(vec2 p){ float v=0., a=.5; for(int i=0;i<5;i++){ v+=a*noise(p); p=p*2.03+17.1; a*=.5; } return v; }
`;

/* ───────────────────────── background (in-scene so the glass refracts it) ───────────────────────── */
const bgU = {
  uTime:{value:0}, uTheme:{value:PRODUCTS[active].theme}, uDim:{value:0}, uAspect:{value:1},
  uPortrait:{value:0}, uMouse:{value:new THREE.Vector2()}, uRes:{value:new THREE.Vector2(1,1)},
};
const bg = new THREE.Mesh(new THREE.PlaneGeometry(2,2), new THREE.ShaderMaterial({
  uniforms:bgU, depthWrite:false, depthTest:false, toneMapped:false,
  vertexShader:/* glsl */`varying vec2 vUv; void main(){ vUv=uv; gl_Position=vec4(position.xy,0.9999,1.0); }`,
  fragmentShader:/* glsl */`
    varying vec2 vUv;
    uniform float uTime, uTheme, uDim, uAspect, uPortrait; uniform vec2 uMouse, uRes;
    ${NOISE}
    vec2 arcC(){ return mix(vec2(-0.80,-1.05), vec2(-0.25,-1.25), uPortrait) + uMouse*vec2(0.015,0.01); }
    float arcR(){ return mix(1.75, 1.35, uPortrait); }
    vec2 sunP(){ return arcC() + arcR()*normalize(mix(vec2(.72,.69), vec2(.30,.95), uPortrait)); }

    vec3 horizonSky(vec2 p){
      float d = length(p - arcC()) - arcR();
      float sd = max(d, 0.);
      vec3 sky = mix(vec3(1.0,.84,.58), vec3(.95,.50,.22), smoothstep(0.,.32,sd));
      sky = mix(sky, vec3(.40,.13,.06), smoothstep(.28,1.25,sd));
      sky += vec3(1.,.78,.5) * exp(-length(p - sunP())*3.0) * .55;
      sky += (fbm(p*2.2 + vec2(uTime*.01,0.)) - .5) * .05;
      vec3 planet = mix(vec3(.028,.024,.026), vec3(.085,.058,.048), smoothstep(-.7,0.,d));
      planet += vec3(1.,.55,.25) * exp(d*22.) * .28;
      vec3 col = mix(planet, sky, smoothstep(-.003,.003,d));
      col += vec3(1.,.86,.62) * exp(-abs(d)*110.) * .55;
      return col;
    }
    vec3 horizonMacro(vec2 p){
      vec3 c = vec3(.018,.015,.016);
      c += vec3(.36,.15,.05) * exp(-length(p - vec2(.18*uAspect, .05))*1.6) * .9;
      c += vec3(.9,.45,.18) * exp(-length(p - vec2(.42*uAspect, .42))*3.5) * .12;
      return c;
    }
    vec3 daydream(vec2 p){
      float n  = fbm(p*1.5 + vec2(uTime*.012, uTime*.006));
      float n2 = fbm(p*3.0 - vec2(uTime*.018, 0.));
      vec3 col = mix(vec3(.955,.935,.90), vec3(.99,.978,.955), smoothstep(-.5,.6,p.y));
      col = mix(col, vec3(.975,.86,.75), smoothstep(.42,.86,n)*.55);
      col = mix(col, vec3(.90,.82,.68), smoothstep(.55,.92,n2)*.22);
      col += vec3(1.,.94,.84) * exp(-length(p - sunP())*2.2) * .22;
      return col;
    }
    vec3 daydreamMacro(vec2 p){
      vec3 c = mix(vec3(.90,.885,.86), vec3(.975,.965,.95), exp(-length(p - vec2(.15*uAspect,.05))*1.4));
      return c;
    }
    void main(){
      vec2 p = (vUv - .5) * vec2(uAspect, 1.);
      vec3 h = mix(horizonSky(p), horizonMacro(p), uDim);
      vec3 d = mix(daydream(p), daydreamMacro(p), uDim);
      float r = length(p - sunP()) + (fbm(p*3.5 + uTime*.05) - .5) * .35;
      float R = uTheme * 3.2;
      float m = 1. - smoothstep(R - .25, R, r);
      vec3 col = mix(d, h, m);
      col += (hash(vUv*uRes + fract(uTime*7.)) - .5) * .022;
      gl_FragColor = vec4(pow(max(col, 0.), vec3(2.2)), 1.);
      #include <colorspace_fragment>
    }`,
}));
bg.frustumCulled = false; bg.renderOrder = -100;
scene.add(bg);

/* ───────────────────────── bottle ───────────────────────── */
const V2 = (x,y) => new THREE.Vector2(x,y);
function lathe(pts, seg = 112){ const g = new THREE.LatheGeometry(pts.map(([x,y]) => V2(x,y)), seg); g.computeVertexNormals(); return g; }
function arc(r0, y0, r1, h, n = 18){ const out=[]; for(let i=0;i<=n;i++){ const t=i/n*Math.PI/2; out.push([r1+(r0-r1)*Math.cos(t), y0+h*Math.sin(t)]); } return out; }

const BODY_R = 0.5, SH_Y = 1.52;
const glassProfile = [[0,0],[0.44,0],[0.484,0.008],[0.5,0.04],[0.5,SH_Y], ...arc(0.5,SH_Y,0.165,0.24).slice(1), [0.165,1.845],[0.17,1.855],[0,1.855]];
const liquidProfile = (fill) => [[0,0.11],[0.448,0.11],[0.468,0.13],[0.468,fill],[0,fill]];

const uGlassBase = { value: 0.04 }, uGlassFr = { value: 0.7 };
function glassMat(side){
  const m = new THREE.MeshPhysicalMaterial({
    color:0x000000, metalness:0, roughness:0.035, transparent:true, side, depthWrite:false,
    envMapIntensity:1.5, clearcoat:1, clearcoatRoughness:0.03, ior:1.5, specularIntensity:1,
  });
  m.onBeforeCompile = (sh) => {
    sh.uniforms.uBase = uGlassBase; sh.uniforms.uFr = uGlassFr;
    sh.fragmentShader = 'uniform float uBase, uFr;\n' + sh.fragmentShader.replace('#include <dithering_fragment>', /* glsl */`
      {
        float fr = pow(1.0 - abs(dot(normalize(normal), normalize(vViewPosition))), 3.0);
        float lum = dot(gl_FragColor.rgb, vec3(.299,.587,.114));
        gl_FragColor.a = clamp(uBase + fr * uFr + lum * 1.1, 0., .96);
      }
      #include <dithering_fragment>`);
  };
  return m;
}

function labelTexture(p){
  const W = 1368, H = 1200, L = 118;
  const c = document.createElement('canvas'); c.width = W; c.height = H;
  const g = c.getContext('2d');
  g.fillStyle = p.label.paper; g.fillRect(0,0,W,H);
  for (let i=0;i<9000;i++){ g.fillStyle = `rgba(0,0,0,${Math.random()*0.035})`; g.fillRect(Math.random()*W, Math.random()*H, 2, 2); }
  g.fillStyle = p.label.ink; g.textBaseline = 'alphabetic';
  g.font = p.label.titleFont; g.fillText(p.label.title, L, 262);
  g.globalAlpha = .85; g.font = '400 62px Roboto'; g.fillText(p.label.size, L, 362); g.globalAlpha = 1;
  g.fillRect(0, 432, W, 5);
  g.font = 'italic 700 80px Roboto'; g.fillText(p.label.notes, L, 560);
  g.globalAlpha = .9; g.font = '400 66px Roboto';
  g.font = '400 62px Roboto';
  g.fillText('Hand Crafted In: Port St. Lucie, Florida', L, 690);
  g.fillText('On: 08/18/2026', L, 778);
  g.fillText('For: You', L, 866);
  g.globalAlpha = 1; g.fillRect(0, 936, W, 5);
  g.globalAlpha = .9; g.font = '400 57px Roboto';
  g.fillText('Aromatick • Your Signature Scent For Less', L, 1040);
  g.textAlign = 'center'; g.fillText('www.aromatick.com', W*0.52, 1124);
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = renderer.capabilities.getMaxAnisotropy();
  return t;
}

const LABEL = { y0:0.12, y1:1.18, theta:2.4, r:0.506 };
const silver = new THREE.MeshPhysicalMaterial({ color:0xe2e4e8, metalness:1, roughness:0.16, envMapIntensity:1.6, clearcoat:0.4, clearcoatRoughness:0.2 });
const darkPlastic = new THREE.MeshStandardMaterial({ color:0x0c0c0d, roughness:0.5 });

function buildBottle(p){
  const g = new THREE.Group(), spin = new THREE.Group(); g.add(spin);
  // liquid (transmissive: refracts the background, label and dip tube)
  const liquidMat = new THREE.MeshPhysicalMaterial({
    color:0xffffff, metalness:0, roughness:0, transmission:1, thickness:0.95, ior:1.36,
    attenuationColor:new THREE.Color(p.liquid.tint), attenuationDistance:p.liquid.dist,
    envMapIntensity:0.7, specularIntensity:0.7,
    emissive:new THREE.Color(p.liquid.glow), emissiveIntensity:1,
  });
  spin.add(new THREE.Mesh(lathe(liquidProfile(1.47)), liquidMat));
  // thick glass base
  const baseMat = new THREE.MeshPhysicalMaterial({ color:0xffffff, roughness:0.02, transmission:1, thickness:0.3, ior:1.5,
    attenuationColor:new THREE.Color('#e9f2ee'), attenuationDistance:1.2, envMapIntensity:1 });
  spin.add(new THREE.Mesh(lathe([[0,0.012],[0.47,0.012],[0.48,0.06],[0.47,0.105],[0,0.105]]), baseMat));
  // dip tube (opaque so it shows refracted through the liquid)
  const tube = new THREE.Mesh(new THREE.CylinderGeometry(0.0095, 0.0095, 1.76, 10),
    new THREE.MeshStandardMaterial({ color:0xe8e4dc, roughness:0.25, metalness:0, transparent:false }));
  tube.position.y = 0.13 + 1.76/2; spin.add(tube);
  // label: printed front + plain paper back (seen through the liquid)
  const labelMat = new THREE.MeshStandardMaterial({ map:labelTexture(p), roughness:0.82, metalness:0, envMapIntensity:0.9 });
  const labelGeo = new THREE.CylinderGeometry(LABEL.r, LABEL.r, LABEL.y1-LABEL.y0, 112, 1, true, -LABEL.theta/2, LABEL.theta);
  const label = new THREE.Mesh(labelGeo, labelMat); label.position.y = (LABEL.y0+LABEL.y1)/2; spin.add(label);
  const labelBack = new THREE.Mesh(labelGeo, new THREE.MeshStandardMaterial({ color:p.label.paper, roughness:0.9, side:THREE.BackSide }));
  labelBack.position.copy(label.position); labelBack.scale.setScalar(0.998); spin.add(labelBack);
  // glass shell (back walls first, then front)
  const gB = new THREE.Mesh(lathe(glassProfile), glassMat(THREE.BackSide)); gB.renderOrder = 1; spin.add(gB);
  const gF = new THREE.Mesh(lathe(glassProfile), glassMat(THREE.FrontSide)); gF.renderOrder = 3; spin.add(gF);
  // atomizer: crimp collar + actuator + nozzle
  spin.add(new THREE.Mesh(lathe([[0,1.84],[0.172,1.84],[0.178,1.85],[0.178,1.925],[0.16,1.945],[0.06,1.95],[0,1.95]]), silver));
  spin.add(new THREE.Mesh(lathe([[0,1.95],[0.074,1.95],[0.076,1.96],[0.076,2.09],[0.068,2.105],[0,2.108]], 64), silver));
  const nozzle = new THREE.Mesh(new THREE.CylinderGeometry(0.013,0.013,0.02,20), darkPlastic);
  nozzle.rotation.x = Math.PI/2; nozzle.position.set(0, 2.045, 0.072); spin.add(nozzle);
  // cap (lifts off in the top-notes chapter)
  const cap = new THREE.Group(); spin.add(cap);
  cap.add(new THREE.Mesh(lathe([[0,1.83],[0.186,1.83],[0.19,1.836],[0.19,2.238],[0.186,2.254],[0.172,2.262],[0,2.262]]), silver));
  scene.add(g);
  return { key:p.key, g, spin, cap, w: p.key === active ? 1 : 0, arcDir:1, phase:Math.random()*6.28,
    nozzle:new THREE.Vector3(0, 2.045, 0.08) };
}
const bottles = { daydream: buildBottle(PRODUCTS.daydream), horizon: buildBottle(PRODUCTS.horizon) };

/* ───────────────────────── giant price type (behind the bottle, refracted by it) ───────────────────────── */
let GIANT_TEXT_W = 0.55;
function priceTexture(){
  const W = 2048, H = 1024, c = document.createElement('canvas'); c.width = W; c.height = H;
  const g = c.getContext('2d'); g.fillStyle = '#fff'; g.textAlign = 'center'; g.textBaseline = 'alphabetic';
  const PRICE = CFG.giant || '$45';
  g.textAlign = 'left'; g.font = '800 640px "DM Sans"'; g.fillText(PRICE, 40, 820);
  GIANT_TEXT_W = (40 + g.measureText(PRICE).width) / W;
  const t = new THREE.CanvasTexture(c); t.anisotropy = 8; return t;
}
const giantU = { uMap:{value:priceTexture()}, uReveal:{value:0}, uColor:{value:new THREE.Color()} };
const giant = new THREE.Mesh(new THREE.PlaneGeometry(8, 4), new THREE.ShaderMaterial({
  uniforms:giantU, toneMapped:false,
  vertexShader:/* glsl */`varying vec2 vUv; void main(){ vUv=uv; gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.); }`,
  fragmentShader:/* glsl */`
    varying vec2 vUv; uniform sampler2D uMap; uniform float uReveal; uniform vec3 uColor;
    ${NOISE}
    void main(){
      float a = texture2D(uMap, vUv).a;
      float edge = (1. - vUv.y) * .7 + vUv.x * .15 + noise(vUv*vec2(40.,20.)) * .15;
      if (a < .5 || edge > uReveal * 1.1 - .02) discard;
      gl_FragColor = vec4(pow(uColor, vec3(2.2)), 1.);
      #include <colorspace_fragment>
    }`,
}));
giant.position.set(0, 1.1, -2.4); giant.visible = false; scene.add(giant);

/* ───────────────────────── particles: ambient motes + atomizer mist ───────────────────────── */
function seeds(n, spread){
  const pos = new Float32Array(n*3), sd = new Float32Array(n*4);
  for (let i=0;i<n;i++){
    pos[i*3]   = (Math.random()-.5)*spread[0]; pos[i*3+1] = Math.random()*spread[1] - 1.5; pos[i*3+2] = (Math.random()-.5)*spread[2];
    for (let k=0;k<4;k++) sd[i*4+k] = Math.random();
  }
  const g = new THREE.BufferGeometry();
  g.setAttribute('position', new THREE.BufferAttribute(pos,3)); g.setAttribute('aSeed', new THREE.BufferAttribute(sd,4));
  return g;
}
const isSmall = Math.min(innerWidth, innerHeight) < 700;
const moteU = { uTime:{value:0}, uPix:{value:20}, uColor:{value:new THREE.Color()}, uAlpha:{value:1} };
const motes = new THREE.Points(seeds(isSmall ? 160 : 320, [9,6,6]), new THREE.ShaderMaterial({
  uniforms:moteU, transparent:true, depthWrite:false,
  vertexShader:/* glsl */`
    attribute vec4 aSeed; uniform float uTime, uPix; varying float vA;
    void main(){
      vec3 p = position;
      p.y = mod(p.y + 1.5 + uTime*(.04 + aSeed.x*.07), 6.) - 1.5;
      p.x += sin(uTime*.3 + aSeed.y*6.283)*.18; p.z += cos(uTime*.25 + aSeed.z*6.283)*.18;
      vec4 mv = modelViewMatrix * vec4(p,1.); gl_Position = projectionMatrix * mv;
      gl_PointSize = (1. + aSeed.w*2.6) * uPix / -mv.z;
      vA = .35 + .65*(.5 + .5*sin(uTime*1.3 + aSeed.x*40.));
      vA *= smoothstep(-1.5,-.8,p.y) * (1. - smoothstep(3.6,4.5,p.y));
    }`,
  fragmentShader:/* glsl */`
    varying float vA; uniform vec3 uColor; uniform float uAlpha;
    void main(){ float d = length(gl_PointCoord - .5); float a = smoothstep(.5, 0., d);
      gl_FragColor = vec4(pow(uColor, vec3(2.2)), a*a*vA*uAlpha);
      #include <colorspace_fragment>
    }`,
}));
motes.frustumCulled = false; motes.renderOrder = 5; scene.add(motes);

const mistU = { uTime:{value:0}, uPix:{value:20}, uSpray:{value:0}, uOrigin:{value:new THREE.Vector3()},
  uDir:{value:new THREE.Vector3(-1,0,0)}, uColor:{value:new THREE.Color()}, uAlpha:{value:1} };
const mist = new THREE.Points(seeds(isSmall ? 800 : 1600, [1,1,1]), new THREE.ShaderMaterial({
  uniforms:mistU, transparent:true, depthWrite:false,
  vertexShader:/* glsl */`
    attribute vec4 aSeed; uniform float uTime, uPix, uSpray; uniform vec3 uOrigin, uDir; varying float vA;
    void main(){
      float life = fract(aSeed.x + uTime*.42);
      vec3 side = normalize(cross(uDir, vec3(0.,1.,0.))); vec3 up = normalize(cross(side, uDir));
      float spread = life*.10 + life*life*.62;
      vec3 p = uOrigin + uDir*(life*1.05 + life*life*.55)
             + (side*(aSeed.y-.5) + up*(aSeed.z-.5)) * spread * 2.
             + vec3(0., life*life*.22, 0.);
      vec4 mv = viewMatrix * vec4(p,1.); gl_Position = projectionMatrix * mv;
      gl_PointSize = (0.7 + 5.5*life*(.3+aSeed.w)) * uPix / -mv.z;
      vA = (1.-life) * smoothstep(0.,.05,life) * uSpray * (.25 + .75*aSeed.w);
    }`,
  fragmentShader:/* glsl */`
    varying float vA; uniform vec3 uColor; uniform float uAlpha;
    void main(){ float d = length(gl_PointCoord - .5); float a = smoothstep(.5, 0., d);
      gl_FragColor = vec4(pow(uColor, vec3(2.2)), a*vA*.5*uAlpha);
      #include <colorspace_fragment>
    }`,
}));
mist.frustumCulled = false; mist.renderOrder = 6; scene.add(mist);

/* ───────────────────────── theme ───────────────────────── */
const THEME = {
  horizon:  { mote:new THREE.Color('#ffc47c'), mist:new THREE.Color('#fff0dc'), giant:new THREE.Color('#c08a5a'), glass:0.035, fr:0.7, moteA:1.0 },
  daydream: { mote:new THREE.Color('#b98b52'), mist:new THREE.Color('#a39176'), giant:new THREE.Color('#d2bb98'), glass:0.015, fr:0.32, moteA:0.55 },
};
function applyThemeInstant(k){
  const T = THEME[k];
  moteU.uColor.value.copy(T.mote); moteU.uAlpha.value = T.moteA; mistU.uColor.value.copy(T.mist);
  giantU.uColor.value.copy(T.giant); uGlassBase.value = T.glass; uGlassFr.value = T.fr;
}
applyThemeInstant(active);

function setProduct(k, instant = false){
  if (k === active) return;
  const prev = active; active = k;
  const p = PRODUCTS[k], T = THEME[k], d = instant || reduced ? 0 : 1.4;
  bottles[k].arcDir = 1; bottles[prev].arcDir = -1;
  gsap.to(bottles[k], { w:1, duration:d, ease:'power3.inOut' });
  gsap.to(bottles[prev], { w:0, duration:d, ease:'power3.inOut' });
  gsap.to(bgU.uTheme, { value:p.theme, duration:d*1.1, ease:'power2.inOut',
    onUpdate(){ scene.environment = bgU.uTheme.value > .5 ? ENV.dark : ENV.light; } });
  if (d === 0) scene.environment = p.theme > .5 ? ENV.dark : ENV.light;
  gsap.to(moteU.uColor.value, { r:T.mote.r, g:T.mote.g, b:T.mote.b, duration:d });
  gsap.to(mistU.uColor.value, { r:T.mist.r, g:T.mist.g, b:T.mist.b, duration:d });
  gsap.to(giantU.uColor.value, { r:T.giant.r, g:T.giant.g, b:T.giant.b, duration:d });
  gsap.to(moteU.uAlpha, { value:T.moteA, duration:d });
  gsap.to(uGlassBase, { value:T.glass, duration:d }); gsap.to(uGlassFr, { value:T.fr, duration:d });
  const copies = $$('.ash-copy');
  if (d === 0) { fillCopy(p); return; }
  gsap.to(copies, { opacity:0, y:8, duration:.25, ease:'power1.in', onComplete(){
    fillCopy(p);
    gsap.to(copies, { opacity:1, y:0, duration:.5, ease:'power2.out', stagger:.03 });
  }});
  root.dataset.theme = k; // flip CSS vars immediately so they cross-fade with the WebGL wipe
}
$$('.ash-tab').forEach(t => t.addEventListener('click', () => setProduct(t.dataset.p)));

/* ───────────────────────── camera keys & layout ───────────────────────── */
// [camera position, look-at target] per chapter: hero, top (atomizer), heart (label), base (liquid), price
const KEYS = {
  wide: [
    { p:[-0.42,1.38,6.4], t:[-0.98,1.12,0] },
    { p:[ 0.40,2.12,1.42], t:[-0.17,1.99,0] },
    { p:[ 0.30,0.82,3.25], t:[-0.50,0.72,0.4] },
    { p:[ 0.45,0.36,1.95], t:[-0.30,0.42,0] },
    { p:[-0.38,1.30,7.4], t:[-0.78,1.10,0] },
  ],
  tall: [
    { p:[ 0.30,0.55,9.6], t:[ 0.12,0.12,0] },
    { p:[ 0.35,2.08,1.75], t:[ 0.00,1.86,0] },
    { p:[ 0.22,0.55,4.7], t:[ 0.06,0.22,0.4] },
    { p:[ 0.40,0.30,2.4], t:[ 0.00,0.04,0] },
    { p:[ 0.00,0.95,13.0], t:[ 0.00,0.35,0] },
  ],
};
const SIDE = { wide:new THREE.Vector3(1.3,0.42,-2.1), tall:new THREE.Vector3(0.95,0.75,-2.4) };
let layout = 'wide', W = 1, H = 1;
function resize(){
  W = root.querySelector('.ash-sticky').clientWidth; H = root.querySelector('.ash-sticky').clientHeight;
  renderer.setSize(W, H, false);
  camera.aspect = W/H; camera.updateProjectionMatrix();
  layout = W/H < 0.85 ? 'tall' : 'wide';
  bgU.uAspect.value = W/H; bgU.uPortrait.value = layout === 'tall' ? 1 : 0; bgU.uRes.value.set(W*DPR, H*DPR);
  const pix = H * DPR * 0.012; moteU.uPix.value = pix; mistU.uPix.value = pix;
  // place the left edge of "$45" just right of the bottle axis (wide) or centre it (tall)
  const gs = layout === 'tall' ? 0.5 : 0.7, textHalf = (GIANT_TEXT_W * 8 * gs) / 2;
  giant.scale.setScalar(gs);
  if (layout === 'tall') giant.position.set(4*gs - textHalf, 3.05, -2.4);
  else giant.position.set(4*gs - 0.15*gs + 0.05, 1.32, -2.4);
}
resize();
addEventListener('resize', () => { syncHdr(); applyCurtain(); resize(); ScrollTrigger.refresh(); });
addEventListener('load', () => { syncHdr(); applyCurtain(); resize(); ScrollTrigger.refresh(); });

/* ───────────────────────── scroll timeline ───────────────────────── */
const S = { cam:0, cap:0, out:0, dim:0, rotY:-0.2, spray:0, top:0, heart:0, base:0, giant:0 };
const P = { hero:$('.ash-hero'), top:$('[data-ch=top]'), heart:$('[data-ch=heart]'), base:$('[data-ch=base]'), price:$('[data-ch=price]'), hint:$('.ash-hint') };
const IN = { autoAlpha:1, y:0, duration:.5, ease:'power2.out' };
const OUT = { autoAlpha:0, y:-30, duration:.4, ease:'power1.in' };
const tl = gsap.timeline({ paused:true, defaults:{ ease:'power2.inOut' } });
tl.addLabel('hero', 0)
  .to(P.hint, { autoAlpha:0, duration:.3, ease:'none' }, 0.05)
  .to(P.hero, { autoAlpha:0, y:-40, duration:.6, ease:'power1.in' }, 0.5)
  .to(S, { cam:1, duration:1.7 }, 0.8)
  .to(S, { out:1, duration:1.2 }, 0.8)
  .to(S, { dim:1, duration:1.3 }, 1.0)
  .to(S, { rotY:-0.95, duration:1.7 }, 0.8)
  .to(S, { cap:1, duration:1.0, ease:'power3.inOut' }, 1.45)
  .fromTo(P.top, { autoAlpha:0, y:30 }, IN, 2.3)
  .to(S, { top:1, duration:.6, ease:'power2.out' }, 2.45)
  .to(S, { spray:1, duration:.35, ease:'none' }, 2.45)
  .addLabel('top', 2.95)
  .to(S, { spray:0, duration:.45, ease:'none' }, 3.6)
  .to(S, { top:0, duration:.3, ease:'none' }, 3.85)
  .to(P.top, OUT, 3.9)
  .to(S, { cam:2, duration:1.5 }, 4.0)
  .to(S, { cap:0, duration:.9 }, 4.0)
  .to(S, { rotY:0.15, duration:1.5 }, 4.0)
  .fromTo(P.heart, { autoAlpha:0, y:30 }, IN, 5.3)
  .to(S, { heart:1, duration:.6, ease:'power2.out' }, 5.45)
  .addLabel('heart', 5.95)
  .to(S, { heart:0, duration:.3, ease:'none' }, 6.65)
  .to(P.heart, OUT, 6.7)
  .to(S, { cam:3, duration:1.5 }, 6.8)
  .to(S, { rotY:Math.PI + 1.05, duration:1.6 }, 6.8)
  .fromTo(P.base, { autoAlpha:0, y:30 }, IN, 8.1)
  .to(S, { base:1, duration:.6, ease:'power2.out' }, 8.25)
  .addLabel('base', 8.75)
  .to(S, { base:0, duration:.3, ease:'none' }, 9.45)
  .to(P.base, OUT, 9.5)
  .to(S, { cam:4, duration:1.6 }, 9.6)
  .to(S, { rotY:Math.PI*2 - 0.3, duration:1.8 }, 9.6)
  .to(S, { giant:1, duration:1.3, ease:'power2.out' }, 10.3)
  .fromTo(P.price, { autoAlpha:0, y:30 }, { ...IN, duration:.6 }, 11.0)
  .addLabel('price', 11.6)
  .to({}, { duration:.8 }, 11.6);

let st = null;
const nextSec = root.parentElement.nextElementSibling;
const useCurtain = !reduced && CFG.curtain !== false && !!nextSec && nextSec.classList.contains('shopify-section');
function curtainOverlap(){ return useCurtain ? Math.round(Math.min(nextSec.offsetHeight, innerHeight - headerOffset())) : 0; }
function applyCurtain(){
  if (!useCurtain) return;
  const o = curtainOverlap();
  nextSec.classList.add('ash-curtain-next'); nextSec.style.marginTop = (-o) + 'px';
  root.style.setProperty('--ash-overlap', o + 'px');
}
applyCurtain();
if (!reduced){
  st = ScrollTrigger.create({ trigger:root, start:() => `top ${headerOffset()}px`, end:() => `bottom-=${curtainOverlap()} bottom`, scrub:1.1, animation:tl, invalidateOnRefresh:true });
}
function goTo(label){
  if (!st) return;
  const y = st.start + (tl.labels[label] / tl.duration()) * (st.end - st.start);
  gsap.to(window, { scrollTo:y, duration:Math.min(2.4, 0.8 + Math.abs(y - scrollY) / 2500), ease:'power2.inOut' });
}
$$('[data-go]').forEach(b => b.addEventListener('click', () => goTo(b.dataset.go)));
const chapBtns = $$('.ash-chap');
const navEl = $('.ash-chapters');

/* ───────────────────────── pointer: parallax + drag-to-spin ───────────────────────── */
const mouse = new THREE.Vector2(), mouseS = new THREE.Vector2();
let drag = 0, dragV = 0, dragging = false, lastX = 0;
addEventListener('pointermove', e => {
  mouse.set(e.clientX / innerWidth * 2 - 1, -(e.clientY / innerHeight * 2 - 1));
  if (dragging){ const dx = e.clientX - lastX; lastX = e.clientX; dragV = dx * 0.0085; drag += dragV; }
}, { passive:true });
canvas.addEventListener('pointerdown', e => {
  if (S.cam > 0.35 && S.cam < 3.6) return;
  dragging = true; lastX = e.clientX; dragV = 0; canvas.classList.add('is-drag');
});
addEventListener('pointerup', () => { dragging = false; canvas.classList.remove('is-drag'); });

/* ───────────────────────── callouts ───────────────────────── */
const ANCHORS = {
  top:   new THREE.Vector3(0, 2.045, 0.085),
  heart: new THREE.Vector3(LABEL.r*Math.sin(-LABEL.theta/2 + 0.05), 0.69, LABEL.r*Math.cos(-LABEL.theta/2 + 0.05)),
  base:  new THREE.Vector3(0.08, 0.32, 0.12),
};
const lines = Object.fromEntries(['top','heart','base'].map(k => {
  const g = $(`[data-line=${k}]`); return [k, { line:g.querySelector('line'), ring:g.querySelector('.ring'), dot:g.querySelector('.dot') }];
}));
const tmp = new THREE.Vector3();
function project(v, obj){ tmp.copy(v).applyMatrix4(obj.matrixWorld).project(camera); return [(tmp.x+1)/2*W, (1-tmp.y)/2*H]; }
function updateCallouts(b, t){
  for (const k of ['top','heart','base']){
    const L = lines[k], prog = S[k];
    if (prog <= 0.001){ L.line.setAttribute('x1',0); L.line.setAttribute('x2',0); L.line.setAttribute('y1',0); L.line.setAttribute('y2',0); L.ring.setAttribute('r',0); L.dot.setAttribute('r',0); continue; }
    const [ax, ay] = project(ANCHORS[k], b.spin);
    const panel = P[k], rule = panel.querySelector('.ash-rule');
    // wide: slide the panel so its rule sits on the anchor's horizon line (like the reference's lens callout)
    if (layout === 'wide'){
      const pr = panel.getBoundingClientRect(), rr = rule.getBoundingClientRect();
      const off = rr.top - pr.top;
      const top = Math.max(80, Math.min(H - pr.height - 40, ay - off));
      panel.style.top = top + 'px'; panel.style.transform = 'none';
    }
    const rr = rule.getBoundingClientRect(), sr = root.querySelector('.ash-sticky').getBoundingClientRect();
    const x1 = layout === 'wide' ? rr.right - sr.left : rr.left - sr.left + 28;
    const y1 = layout === 'wide' ? rr.top - sr.top + 0.5 : panel.getBoundingClientRect().top - sr.top - 14;
    const e = Math.min(1, prog / 0.85);
    L.line.setAttribute('x1', x1); L.line.setAttribute('y1', y1);
    L.line.setAttribute('x2', x1 + (ax - x1)*e); L.line.setAttribute('y2', y1 + (ay - y1)*e);
    const dotK = Math.max(0, (prog - 0.8) / 0.2);
    L.dot.setAttribute('cx', ax); L.dot.setAttribute('cy', ay); L.dot.setAttribute('r', 3.5*dotK);
    const pulse = (t*0.8) % 1;
    L.ring.setAttribute('cx', ax); L.ring.setAttribute('cy', ay); L.ring.setAttribute('r', (8 + pulse*16)*dotK);
    L.ring.style.opacity = (1 - pulse) * dotK;
  }
}

/* ───────────────────────── render loop ───────────────────────── */
let running = true;
new IntersectionObserver(([en]) => { running = en.isIntersecting; }, { rootMargin:'100px' }).observe(root);
const clock = new THREE.Clock();
const camPos = new THREE.Vector3(), camTgt = new THREE.Vector3(), a = new THREE.Vector3(), bV = new THREE.Vector3();
const outOff = new THREE.Vector3(2.8, 0.5, -1.4), origin = new THREE.Vector3();
const lerp = (x,y,f) => x + (y-x)*f;

function frame(){
  requestAnimationFrame(frame);
  if (!running || document.hidden || (st && scrollY > st.end + innerHeight)) { clock.getDelta(); return; }
  clock.getDelta();
  const t = reduced ? 2.0 : clock.elapsedTime;
  const c = Math.max(0, Math.min(4, S.cam)), i = Math.min(3, Math.floor(c)), f = c - i;
  const hf = Math.max(0, Math.min(1, Math.max(1 - c, c - 3)));    // 1 in hero/finale, 0 in macro

  // drag spin with inertia, springs back to the nearest full turn
  if (!dragging){ dragV *= 0.94; drag += dragV; drag += (Math.round(drag/(Math.PI*2))*Math.PI*2 - drag) * 0.035; }

  // camera
  const K = KEYS[layout];
  a.fromArray(K[i].p); bV.fromArray(K[i+1].p); camPos.lerpVectors(a, bV, f);
  a.fromArray(K[i].t); bV.fromArray(K[i+1].t); camTgt.lerpVectors(a, bV, f);
  mouseS.lerp(mouse, 0.05);
  camPos.x += mouseS.x * (0.28*hf + 0.03); camPos.y += mouseS.y * (0.16*hf + 0.02);
  camera.position.copy(camPos); camera.lookAt(camTgt);

  // bottles
  for (const b of Object.values(bottles)){
    const w = b.w, side = SIDE[layout];
    a.copy(side).addScaledVector(outOff, S.out);
    b.g.position.lerpVectors(a, origin, w);
    const arcK = Math.sin(Math.PI * w);
    b.g.position.y += arcK * 0.3; b.g.position.z += arcK * 0.75 * b.arcDir; b.g.position.x += arcK * -0.2 * b.arcDir;
    b.g.position.y += Math.sin(t*0.9 + b.phase) * 0.045 * (hf*0.85 + 0.15*(1-w));
    b.g.rotation.z = (w*0.05 + (1-w)*-0.1) * hf;
    b.spin.rotation.y = w * (S.rotY + drag + Math.sin(t*0.35)*0.12*hf) + (1-w) * (-0.6 + Math.sin(t*0.3 + 1.0)*0.12);
    const lift = S.cap * w;
    b.cap.position.set(lift*0.42, lift*1.05, -lift*0.25); b.cap.rotation.z = -lift*0.6;
    b.g.visible = !(w < 0.001 && S.out > 0.999);
  }
  const act = bottles[active];
  act.g.updateMatrixWorld(true);

  // mist from the active nozzle, along the nozzle's facing
  mistU.uOrigin.value.copy(act.nozzle).applyMatrix4(act.spin.matrixWorld);
  mistU.uDir.value.set(Math.sin(act.spin.rotation.y), 0.08, Math.cos(act.spin.rotation.y)).normalize();
  mistU.uSpray.value = S.spray * act.w; mistU.uTime.value = t;
  mist.visible = S.spray > 0.001;

  bgU.uTime.value = t; bgU.uDim.value = S.dim; bgU.uMouse.value.copy(mouseS);
  moteU.uTime.value = t;
  giantU.uReveal.value = S.giant; giant.visible = S.giant > 0.001;

  renderer.render(scene, camera);
  if (!root.classList.contains('ash--ready')) root.classList.add('ash--ready');
  updateCallouts(act, t);

  const chap = c < 0.5 ? -1 : Math.round(c) - 1;
  chapBtns.forEach((btn, k) => btn.classList.toggle('on', k === chap));
  const navA = Math.min(1, Math.max(0, (c - 0.25) / 0.4), Math.max(0, (3.75 - c) / 0.35));
  navEl.style.opacity = navA; navEl.style.visibility = navA > 0.01 ? 'visible' : 'hidden';
}
frame();
window.__ash = { S, tl, setProduct, goTo };
}
